import { types } from 'mobx-state-tree';

const Bookmark = types
  .model({
    path: types.array(types.union(types.string, types.integer)),
    content: types.maybe(types.string),
    note: types.maybe(types.string)
  })
  .views(self => ({}))
  .actions(self => ({}));

export default Bookmark;



// WEBPACK FOOTER //
// ./src/app/state/models/BookmarkModel.js